import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AuditTrialDetails } from '../../shared/models/audits/audit-trial-details';
import { FilterMenu } from '../../shared/models/filter-menu';
import { PanelList } from '../../shared/models/panel-list';
import { SortMenu } from '../../shared/models/sort-menu';

@Component({
  selector: 'app-scope-audit-summary',
  templateUrl: './scope-audit-summary.component.html',
  styleUrls: ['./scope-audit-summary.component.scss']
})
export class ScopeAuditSummaryComponent implements OnInit, OnChanges {
  @Input() summaryData: AuditTrialDetails[] = [];
  @Output() onItemSelected = new EventEmitter<AuditTrialDetails>();
  
  isSummaryLoaded: boolean = false;
  scopeAuditSummaryInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableToggling: false,
    enableSelection: false,
    enablePanelCardClick: true,
    enablePanelHighLight: true
  };

  constructor() {}

  ngOnInit(): void {
    this.bindScopeAuditSummary();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['summaryData']) {
      this.bindScopeAuditSummary();
    }
  }

  bindScopeAuditSummary = () => {
    this.scopeAuditSummaryInput.lists = this.summaryData;
    this.scopeAuditSummaryInput.filters = this.getFiltersForScopeAuditList();
    this.scopeAuditSummaryInput.sort = this.getSortFieldsForScopeAuditList();
    this.scopeAuditSummaryInput.clearSelection = true;
    this.isSummaryLoaded = true;
    this.scopeAuditSummaryInput = { ...this.scopeAuditSummaryInput };
  }

  private getFiltersForScopeAuditList = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'User',
        filterFieldName: 'user',
      },
      {
        filterDisplayName: 'Action',
        filterFieldName: 'action',
      }
    );
    return filters;
  };

  private getSortFieldsForScopeAuditList = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'User',
        sortFieldName: 'user',
      },
      {
        sortFieldDisplayName: 'Action',
        sortFieldName: 'action',
      },
      {
        sortFieldDisplayName: 'Timestamp',
        sortFieldName: 'timestamp',
      }
    );
    return sortMenu;
  };

  showAuditAttributeDetails = (data: any) => {
    this.onItemSelected.emit(data);
  }
}
